export default "__VITE_ASSET__lMC9yoSU__"